import { createSerializer, ParserMap } from 'nuqs';

export const serializeQuery = <TParsers extends ParserMap, TQuery>(parsers: TParsers, query?: TQuery) =>
  query ? createSerializer(parsers)(query) : '';
